var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDoctify = function SvgDoctify(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 90 84"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A7F3D8",
    d: "M74.867 13.214c-13.282-1.39-19.627 9.552-26.644 11.756-.794.068-1.614.075-2.452.056.037.012.074.031.111.044 7.327.632 16.498-3.305 26.153 4.644 17.324 14.26 5.384 41.232-24.83 51.992 1.974.695 4.03 1.32 6.16 1.872 4.128 1.064 8.568.062 12.07-2.385 37.329-26.159 36.783-65.106 9.432-67.979"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#doctify_svg__a)",
    d: "M74.867 13.214c-13.282-1.39-19.627 9.552-26.644 11.756-.794.068-1.614.075-2.452.056.037.012.074.031.111.044 7.327.632 16.498-3.305 26.153 4.644 17.324 14.26 5.384 41.232-24.83 51.992 1.974.695 4.03 1.32 6.16 1.872 4.128 1.064 8.568.062 12.07-2.385 37.329-26.159 36.783-65.106 9.432-67.979"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#doctify_svg__b)",
    d: "M19.654 13.214c13.282-1.39 19.628 9.552 26.644 11.756.795.068 1.614.075 2.453.056-.038.012-.075.031-.112.044-7.327.632-16.498-3.305-26.153 4.644-17.324 14.26-5.384 41.232 24.83 51.992a76 76 0 0 1-6.16 1.872c-4.128 1.064-8.568.062-12.07-2.385-37.33-26.159-36.783-65.106-9.432-67.979"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#doctify_svg__c)",
    d: "M47.208 81.706a83 83 0 0 1-6.44 1.978C20.119 74.013 8.867 56.637 14.263 43.26c-1.82 13.965 10.636 30.61 32.946 38.446"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#doctify_svg__d)",
    d: "M72.035 29.713c-9.655-7.95-18.826-4.012-26.153-4.644-.037-.013-.074-.032-.112-.044-6.873-.15-15.094-2.498-23.7 4.594-17.373 14.31-5.297 41.4 25.128 52.086 30.22-10.76 42.16-37.733 24.837-51.992"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#doctify_svg__e)",
    d: "M34.555 9.66c-4.039-2.263-4.546-7.2-.533-7.998a13.63 13.63 0 0 1 10.08 1.93c5.102 3.31 6.42 11.61 4 16.64-.514 1.066-1.92.998-2.627.048-3.004-4.034-6.88-8.359-10.92-10.62"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "doctify_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(51.09104 -34.0194 34.29547 51.50564 52.413 38.52)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.537,
    stopColor: "#1CDFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AA9C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "doctify_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-48.69594 1.20711 -1.2169 -49.09112 48.696 29.387)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DDFCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992,
    stopColor: "#2B5AE0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "doctify_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-60.44437 -33.40426 33.67532 -60.93485 80.693 65.454)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.088,
    stopColor: "#2B59E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#1DDFCE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "doctify_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(18.47829 12.08121 -11.68606 17.8739 36.139 8.705)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.192,
    stopColor: "#2B59E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.793,
    stopColor: "#1DDFCE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "doctify_svg__c",
    x1: 41.334,
    x2: 15.459,
    y1: 82.205,
    y2: 56.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B59E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: 0
  })))));
};
export default SvgDoctify;